import React from 'react';
import * as styles from './ExternalLinkButton.module.css';

export interface ExternalLinkButtonProps {
  href: string;
  children: React.ReactNode;
  caption?: string;
}

const ExternalLinkButton: React.FC<ExternalLinkButtonProps> = ({
  href,
  children,
  caption,
}) => (
  <div className={styles.externalLinkButtonWrapper}>
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className={styles.externalLinkButton}
    >
      <span className={styles.webIcon}></span>
      <span className={styles.text}>{children}</span>
    </a>
    {caption && <small className={styles.externalLinkCaption}>{caption}</small>}
  </div>
);

export default ExternalLinkButton;
